import Vue from 'vue';
import Echo from 'laravel-echo';
import PortalVue from 'portal-vue';
import App from './App';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './assets/scss/main.scss';
import './registerServiceWorker';

Vue.config.productionTip = false;
Vue.use(PortalVue);
Vue.filter('currency', (value) => `£${value.toFixed(2)}`);

Vue.mixin({
  methods: {
    iOS() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    },
  },
});

window.Pusher = require('pusher-js');

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_APP_KEY,
  cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
  forceTLS: true,
});

window.Echo.channel('menu')
  .listen('MenuUpdated', (e) => {
    store.dispatch('getMenu');
  });

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
